import { EffectCallback, useRef } from "react";
import { useEffectOnce as useHooksEffectOnce } from "usehooks-ts";

export function useEffectOnce(effect: EffectCallback) {
  const called = useRef(false);
  const effectDestructor = useRef<ReturnType<EffectCallback>>(undefined);

  return useHooksEffectOnce(() => {
    if (!called.current) {
      effectDestructor.current = effect();
      called.current = true;
    }
    return effectDestructor.current;
  });
}
